import { uiRows } from './types-def.js';
/**
 * `web/nav` (1.I-2): open modes, split panes, history and focus, moved from `web/shell` in 1.0b
 * stage 2. Open modes follow amendments 2.1 section 7, mandatory fix 10: chips are
 * buttons; click peeks, Mod-click opens the full page, Alt-click a center peek, Shift-click a
 * split pane. No mode opens a browser tab or downloads anything.
 */
export const NAV_INTERACTIONS = uiRows([
    {
        id: 'shell.open.click',
        module: 'web/nav',
        behavior: 'Click on a document chip opens an editable side peek; no browser tab opens and nothing downloads',
        owner: '1.I-2',
        since: 'exit-1a',
    },
    {
        id: 'shell.open.mod-click',
        module: 'web/nav',
        behavior: 'Mod-click opens the document as a full page; no browser tab opens and nothing downloads',
        owner: '1.I-2',
        since: 'exit-1a',
    },
    {
        id: 'shell.open.alt-click',
        module: 'web/nav',
        behavior: 'Alt-click opens a center peek; no browser tab opens and nothing downloads',
        owner: '1.I-2',
        since: 'exit-1a',
    },
    {
        id: 'shell.open.shift-click',
        module: 'web/nav',
        behavior: 'Shift-click opens a split pane; no browser tab opens and nothing downloads',
        owner: '1.I-2',
        since: 'exit-1a',
    },
    {
        id: 'shell.split.max-two',
        module: 'web/nav',
        behavior: 'At most two split panes are open at once',
        owner: '1.I-2',
        since: 'exit-1a',
    },
    {
        id: 'shell.history.per-pane',
        module: 'web/nav',
        behavior: 'Each pane keeps its own back and forward history',
        owner: '1.I-2',
        since: 'exit-1a',
    },
    {
        id: 'shell.focus.return',
        module: 'web/nav',
        behavior: 'Closing a peek, menu or palette returns focus to the element that opened it',
        owner: '1.I-2',
        since: 'exit-1a',
    },
]);
//# sourceMappingURL=nav.js.map